// @ts-nocheck
import { randCatchPhrase, randParagraph } from '@ngneat/falso';
import { createDTB, getDTBLock, updateDTB, removeDTBLock } from '../Library/_data_sources/manageDTB';
import { getIssuedManual } from '../../Policy/IssuedManuals/_data_sources/useIssuedManual';

interface CreateDTBsConfig {
  manualId?: string;
  count?: number;
  dtbLevel?: string;
}

const DEFAULT_CONTEXT_BLOCKS = [
  {
    content: '',
    contentEditable: '',
    contentType: 'CONTENT',
    title: 'Scenario',
  },
  {
    content: '',
    contentEditable: '',
    contentType: 'CONTENT',
    title: 'Rule',
  },
  {
    content: '',
    contentEditable: '',
    contentType: 'CONTENT',
    title: 'Analysis',
  },
  {
    content: '',
    contentEditable: '',
    contentType: 'CONTENT',
    title: 'Conclusion',
  },
];

declare global {
  interface Window {
    createDTBs: (config?: CreateDTBsConfig) => Promise<void>;
  }
}

window.createDTBs = async (config: CreateDTBsConfig = {}) => {
  console.log('Starting createDTBs...', config);
  
  try {
    const {
      manualId,
      count = 10,
      dtbLevel = 'AGENCY'
    } = config;

    // Get current organization ID from localStorage
    const orgId = localStorage.getItem('phx-currentOrganizationId');
    if (!orgId) {
      throw new Error('Could not find organizationId in localStorage');
    }
    console.log('Organization ID:', orgId);

    let manual;
    let allPolicies = [];
    let jurisdictionId = '';

    if (manualId) {
      console.log('Fetching manual data...');
      manual = await getIssuedManual(manualId);
      console.log('Manual data fetched:', manual);

      if (!manual || !manual.chapters) {
        throw new Error('Invalid manual data');
      }

      // Collect all policies from all chapters
      allPolicies = manual.chapters.flatMap(chapter => 
        chapter.policies?.map(policy => ({
          id: policy.id,
          title: policy.title,
          chapterTitle: chapter.title
        })) || []
      );

      if (allPolicies.length === 0) {
        throw new Error('No policies found in manual');
      }

      console.log(`Found ${allPolicies.length} policies in manual`);
      // jurisdictionId = manual.jurisdiction.id;
    }

    // Create DTBs
    const createdDTBs = [];
    for (let i = 0; i < count; i++) {
      // Select a random policy if we have policies
      const selectedPolicy = manualId && allPolicies.length > 0
        ? allPolicies[Math.floor(Math.random() * allPolicies.length)]
        : null;

      // Generate name based on whether we have a selected policy
      const dtbName = selectedPolicy
        ? `${selectedPolicy.title} Training Bulletin`
        : `Training Bulletin ${i + 1}`;

      console.log(`Creating DTB ${i + 1}/${count}: ${dtbName}`);

      try {
        // Create DTB
        const dtb = await new Promise((resolve, reject) => {
          createDTB(
            orgId,
            {
              name: dtbName,
              jurisdictionId: '',
              manualId: manualId || '',
              level: dtbLevel,
              verticalId: '',
            },
            resolve,
            reject
          );
        });

        console.log(`DTB created: ${dtb.id}`);

        // Get lock
        await new Promise((resolve, reject) => {
          getDTBLock(orgId, dtb.id, resolve, reject);
        });

        console.log(`Lock acquired for DTB: ${dtb.id}`);

        // Update with default content blocks and content references if we have a selected policy
        await new Promise((resolve, reject) => {
          updateDTB(
            orgId,
            dtb.id,
            {
              ...dtb,
              jurisdiction: {id: ''},
              contentBlocks: DEFAULT_CONTEXT_BLOCKS,
              contentReferences: selectedPolicy ? [{
                contentUri: `xref://manuals/${manualId}/content/${selectedPolicy.id}`,
                name: `${selectedPolicy.heading}: ${selectedPolicy.title}`
              }] : [],
            },
            resolve,
            reject
          );
        });

        console.log(`Default content blocks and references added to DTB: ${dtb.id}`);

        // Remove lock
        await new Promise((resolve, reject) => {
          removeDTBLock(orgId, dtb.id, resolve, reject);
        });

        console.log(`Lock removed from DTB: ${dtb.id}`);

        createdDTBs.push(dtb);
      } catch (error) {
        console.error(`Error creating DTB ${i + 1}:`, error);
      }
    }

    console.log(`Successfully created ${createdDTBs.length} DTBs`);
    console.log('Created DTBs:', createdDTBs);
  } catch (error) {
    console.error('Error in createDTBs:', error);
  }
}; 